/* __next_internal_client_entry_do_not_use__ SDUIFilterablePaginatedSectionPaginationRenderer auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { logSDUIEvent } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/EventLogging/logSDUIEvent";
import { ActionLoggingEventParams } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/types";
import { PAGE_QUERY_PARAM_KEY } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/consts";
import { FilterablePaginatedSectionContext } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/FilterablePaginatedSectionContext";
import { SDUIFilterablePaginatedSectionNextPagePrefetcher } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Pagination/SDUIFilterablePaginatedSectionNextPagePrefetcher";
import { paginationRow } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/styles.css";
import { useUpdateQueryParam } from "@faire/retailer-visitor-shared/lib/queryParams";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { Pagination } from "@faire/web--source/slate/Pagination";
import { WhenVisibilityIsImminent } from "@faire/web--source/ui/VisibilitySensor/WhenVisibilityIsImminent";
import { trackCategoriesPaginationClick } from "@faire/web-api--source/events/categories/click/pagination";
import React, { useCallback, useContext } from "react";
export var SDUIFilterablePaginatedSectionPaginationRenderer = function(param) {
    var paginationData = param.paginationData, sectionLoggingData = param.sectionLoggingData, filterablePaginatedSection = param.filterablePaginatedSection;
    var handlePaginationLink = function(pageNumber) {
        var currentFilterPath = getCurrentPath().delete(PAGE_QUERY_PARAM_KEY);
        if (pageNumber === 1) {
            return currentFilterPath.toString();
        }
        return currentFilterPath.append({
            page: pageNumber.toString()
        }).toString();
    };
    var _useContext = useContext(FilterablePaginatedSectionContext), scrollToTopFunc = _useContext.scrollToTopFunc, setIsScrollingToTop = _useContext.setIsScrollingToTop, startTransition = _useContext.startTransition;
    var updateQueryParam = useUpdateQueryParam();
    var handlePageChange = useCallback(function(queryParamName, value) {
        return startTransition === null || startTransition === void 0 ? void 0 : startTransition(function() {
            updateQueryParam(queryParamName, value);
        });
    }, [
        startTransition,
        updateQueryParam
    ]);
    var _paginationData_page_count;
    var shouldShowPagination = paginationData && ((_paginationData_page_count = paginationData.page_count) !== null && _paginationData_page_count !== void 0 ? _paginationData_page_count : 0) > 1;
    if (!shouldShowPagination) {
        return null;
    }
    return /*#__PURE__*/ _jsx(WhenVisibilityIsImminent, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: paginationRow,
            "data-test-id": "sdui-fps-pagination",
            children: [
                /*#__PURE__*/ _jsx(SDUIFilterablePaginatedSectionNextPagePrefetcher, {
                    filterablePaginatedSection: filterablePaginatedSection,
                    paginationData: paginationData,
                    handlePaginationLink: handlePaginationLink
                }),
                /*#__PURE__*/ _jsx(Pagination, {
                    paginationData: paginationData,
                    pageToLink: handlePaginationLink,
                    onChangePage: function(page) {
                        logSDUIEvent("CLICK", ActionLoggingEventParams.build(_object_spread_props(_object_spread({}, sectionLoggingData), {
                            action_content: page.toString(),
                            action_instance_identifier: "FETCH_PAGE"
                        })));
                        var _sectionLoggingData_view_instance_identifier;
                        trackCategoriesPaginationClick((_sectionLoggingData_view_instance_identifier = sectionLoggingData.view_instance_identifier) !== null && _sectionLoggingData_view_instance_identifier !== void 0 ? _sectionLoggingData_view_instance_identifier : "", page.toString());
                        scrollToTopFunc === null || scrollToTopFunc === void 0 ? void 0 : scrollToTopFunc({
                            toTop: page === 1
                        });
                        setIsScrollingToTop === null || setIsScrollingToTop === void 0 ? void 0 : setIsScrollingToTop(true);
                        if (page === 1) {
                            handlePageChange(PAGE_QUERY_PARAM_KEY);
                        } else {
                            handlePageChange(PAGE_QUERY_PARAM_KEY, page.toString());
                        }
                    }
                })
            ]
        })
    });
};
